import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { SERVICES, HttpMethods } from '../../../services/api';
import { basicApiAsyncThunkCreator } from '../../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../../rootReducer';
import { DealTypes, ILineItem } from '../hubspotDeals.thunks';
import { isExternalClient } from '../../../utils/clients';

export interface ICurrentDeal {
  amount: number;
  closeDate: string;
  contractEndDate: string;
  contractStartDate: string;
  dealName: string;
  dealType: DealTypes;
  dealTypeDescription: string;
  invoiced: boolean;
  lineItems: ILineItem[];
}

export interface ICurrentRenewalParams {
  accountId: string;
}

interface ICurrentRenewalResponse {
  currentDeal: ICurrentDeal | null;
  renewalDeal: null;
}

export const CURRENT_RENEWAL_THUNK_PREFIX = 'account/fetchCurrentRenewal';
export const getCurrentRenewal: AsyncThunk<ICurrentRenewalResponse | void, ICurrentRenewalParams, ThunkAPI> = createAsyncThunk(
  CURRENT_RENEWAL_THUNK_PREFIX,
  async (data, thunk) => {
    if (isExternalClient()) {
      thunk.dispatch({
        type: 'DO_NOTHING'
      });
      return;
    }
    try {
      const response = await basicApiAsyncThunkCreator<ICurrentRenewalResponse | void, undefined>({
        endpoint: `crm/account/${data.accountId}/current-renewal`,
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Get,
        contentType: 'application/json'
      })(undefined, thunk);
      return response;
    } catch (err) {
      return thunk.rejectWithValue(err);
    }
  }
);
